export enum OrganizationConfigurationName {
  ENABLE_TESTOPS_ADVANCED = 'ENABLE_TESTOPS_ADVANCED',
  KSE_IDLE_TIMEOUT = 'KSE_IDLE_TIMEOUT',
  ENABLE_TESTOPS_INTEGRATION = 'ENABLE_TESTOPS_INTEGRATION',
  SESSION_TIMEOUT = 'SESSION_TIMEOUT',
  MAX_TIMES_CONTINUOUS_KSE = 'MAX_TIMES_CONTINUOUS_KSE',
}
